module.exports = __webpack_public_path__ + "static/background-2-e761f72bcdf9b2958d9022ec421c3cdc.jpg";